import { Reveal } from "./Reveal";
import { whatsappLink } from "../config/site";
import { useLang } from "../config/i18n";

// Foto oficial de Mestre Jonas Barcellos
const PORTRAIT_URL = "/mestre-jonas-barcellos.jpg";

export const About = () => {
  const { t } = useLang();

  return (
    <section id="quem-sou" data-testid="about-section" className="relative py-24 sm:py-36">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-3 border border-[#C5A059]/25 rounded-2xl pointer-events-none" />
            <div className="absolute -top-3 -left-3 w-8 h-8 border-t-2 border-l-2 border-[#C5A059] rounded-tl-2xl" />
            <div className="absolute -bottom-3 -right-3 w-8 h-8 border-b-2 border-r-2 border-[#C5A059] rounded-br-2xl" />
            <img
              data-testid="about-portrait-img"
              src={PORTRAIT_URL}
              alt="Mestre Jonas Barcellos"
              loading="lazy"
              className="w-full aspect-[4/5] max-h-[70vh] object-cover object-top rounded-xl contrast-[1.05]"
            />
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="text-[11px] font-semibold tracking-[0.3em] text-[#C5A059] uppercase mb-5">{t.about.overline}</p>
            <h2 className="font-heading text-3xl sm:text-4xl text-[#F7F7F8] leading-snug mb-8">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <div data-testid="about-story-text" className="space-y-5 text-[15px] sm:text-base text-[#A3A3AF] leading-relaxed font-light">
              {t.about.paragraphs.map((p) => (
                <p key={p.slice(0, 24)}>{p}</p>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <a
              data-testid="about-cta-btn"
              href={whatsappLink(t.about.waMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-10 btn-outline-gold"
            >
              {t.about.cta}
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
